import React, {createContext, useState } from "react";
import { FilterContextType, FilterState } from "../../Types/Filter/FilterContext.type";

export const FilterContext = createContext<FilterContextType | undefined>(undefined);

const FilterContextProvider: React.FC<{ children: React.ReactNode}> = ({ children }) => {
    const [filters, setFiltersState] = useState<FilterState>({
        search: '',
        category: ''
    });

    const setFilters = (newFilters: Partial<FilterState>) => {
        setFiltersState((prev) => ({...prev, ...newFilters}));
    };

    return (
        <FilterContext.Provider value={{filters, setFilters}}>
            { children }
        </FilterContext.Provider>
    );
};

export default FilterContextProvider